module.exports = __webpack_public_path__ + "img/paylah.24cb084c.jpeg";